import { useEffect, useRef } from 'react';
import { confirmAlert } from '@/lib/confirmAlert';

/**
 * beforeunload + request-close guard for dirty React forms (UnsavedChangesGuard parity).
 */
export function useUnsavedGuard(isDirty, { message = 'Discard unsaved changes?' } = {}) {
    const dirtyRef = useRef(isDirty);
    dirtyRef.current = isDirty;

    useEffect(() => {
        const onBeforeUnload = (event) => {
            if (!dirtyRef.current) return;
            event.preventDefault();
            event.returnValue = '';
        };
        window.addEventListener('beforeunload', onBeforeUnload);
        return () => window.removeEventListener('beforeunload', onBeforeUnload);
    }, []);

    const requestClose = async (onClose) => {
        if (dirtyRef.current) {
            const ok = await confirmAlert({
                title: 'Unsaved changes',
                message,
                confirmLabel: 'Discard',
                confirmClass: 'btn-danger',
            });
            if (!ok) return false;
        }
        onClose?.();
        return true;
    };

    return { requestClose };
}
